import React,{useState, useEffect}  from 'react';
import { Card} from 'react-bootstrap';
import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Plambda(){
  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
 
return(
     <div>
<Sides/>

<Helmet>
 
  <title>Learn Free Python Lambda Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python lambda tutorial for beginners Python Lambda function examples use return in simple forma and Python lambda function(inline/anonymous)" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Python lambda,Python Lambda map,Python Lambda function example,
,Python lambda keyword,Lambda inline function,Python Lambda function examples use return" />
<link rel="canonical" href="https://www.codeexampler.com/python-lambda" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Python lambda function(inline/anonymous):</h1>

    <div className="first">
        <a href="/python-continue">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-list">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


    <p className="mt-4 para">Python lambda keyword creates the inline function.</p>


<h2 className='headings'>Q-Python Lambda Mother Function() function examples?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-5">def</span>
                <span className="qwerty-8"> mother</span>
                <span className="qwerty-1"> ()</span>
                <span className="qwerty-1"> :</span>
            {"\n"}
                <span className="qwerty-4">    return</span>
                <span className="qwerty-1">("</span>
                <span className="qwerty-10">maa</span>
                <span className="qwerty-1">")</span>
            {"\n"}
                <span className="qwerty-3">print</span>
                <span className="qwerty-1">(</span>
                <span className="qwerty-8">mother</span>
                <span className="qwerty-6">()</span>
                <span className="qwerty-1">)</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div> 
        <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
               <pre style={{maxHeight:"100vh"}}>
                   <code >
                   {"\n"}
                           <span className="qwerty-2">maa</span>
                           {"\n"}    
                           {"\n"}    
                 </code>
                   </pre>
                   </div> 


<p className="mt-4 para">That creates an inline function with the name mother that returns ‘maa’.<br/>
Lambda can take arguments:
</p>




<h2 className='headings'>Q-Python Lambda function with If Else Examples?</h2>
      <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
     <pre style={{maxHeight:"500vh"}}>
         <code >
           {"\n"}
               <span className="qwerty-5">def</span>
               <span className="qwerty-8"> even_no</span>
               <span className="qwerty-1"> (</span>
               <span className="qwerty-4">n</span>
               <span className="qwerty-1">):</span>
           {"\n"}
                  <span className="qwerty-6">    if</span>
                   <span className="qwerty-1"> (</span>
                   <span className="qwerty-4">n</span>
                   <span className="qwerty">%</span>
                   <span className="qwerty-8">2</span>
                   <span className="qwerty">==</span>
                   <span className="qwerty-2">0</span>
                   <span className="qwerty-1">)</span>
                   <span className="qwerty-1">:</span>
               {"\n"}         
               <span className="qwerty-4">        return</span>
               <span className="qwerty-10"> True</span>
           {"\n"}
           <span className="qwerty-6">    else</span>
                  <span className="qwerty-1"> :</span>
              {"\n"}
               <span className="qwerty-4">        return</span>
               <span className="qwerty-10"> False</span>
           {"\n"}
               <span className="qwerty-3">print</span>
               <span className="qwerty-1">(</span>
               <span className="qwerty-8">even_no</span>
               <span className="qwerty-6">(</span>
               <span className="qwerty-4">6</span>
               <span className="qwerty-6">)</span>
               <span className="qwerty-1">)</span>
           {"\n"}{"\n"}
                </code>
       </pre>
       </div> 
       <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-2">True</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div> 


<h3 className="mt-4 ">But in Python Form:</h3>


<h2 className='headings'>Python Lambda function examples use Return.</h2>
      <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
     <pre style={{maxHeight:"500vh"}}>
         <code >
           {"\n"}
               <span className="qwerty-5">def</span>
               <span className="qwerty-8"> even_no</span>
               <span className="qwerty-1"> (</span>
               <span className="qwerty-4">n</span>
               <span className="qwerty-1">):</span>
               {"\n"}         
               <span className="qwerty-4">    return</span>
                  <span className="qwerty-4"> n</span>
                   <span className="qwerty">%</span>
                   <span className="qwerty-8">2</span>
                   <span className="qwerty">==</span>
                   <span className="qwerty-2">0</span>
           {"\n"}
                  <span className="qwerty-6">if</span>
                   <span className="qwerty-8"> even_no</span>
                   <span className="qwerty-1"> (</span>
               <span className="qwerty-4">9</span>
               <span className="qwerty-1">):</span>
              {"\n"}
              <span className="qwerty-3">    print</span>
                   <span className="qwerty-1">("</span>
                   <span className="qwerty-10">Even</span>
                   <span className="qwerty-1">")</span>
               {"\n"}
           <span className="qwerty-6">else</span>
                  <span className="qwerty-1"> :</span>
              {"\n"}
              <span className="qwerty-3">    print</span>
                   <span className="qwerty-1">("</span>
                   <span className="qwerty-10">Odd</span>
                   <span className="qwerty-1">")</span>
           {"\n"}{"\n"}
                </code>
       </pre>
       </div> 
       <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-2">Odd</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>  


<h2 className="mt-4 mh2">Call function with an argument from inside a Python lambda function:</h2>



      <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
     <pre style={{maxHeight:"500vh"}}>
         <code >
           {"\n"}
               <span className="qwerty-5">def</span>
               <span className="qwerty-8"> lord</span>
               <span className="qwerty-1"> (</span>
               <span className="qwerty-4">name</span>
               <span className="qwerty-1">):</span>
               {"\n"} 
               <span className="qwerty-3">    print</span>
                   <span className="qwerty-1">(</span>
                   <span className="qwerty-4">name</span>
                   <span className="qwerty-1">)</span>
               {"\n"}        
               <span className="qwerty-10">God</span>
                  <span className="qwerty-1"> = </span>
                   <span className="qwerty">lambda</span>
                   <span className="qwerty-4"> x</span>
                   <span className="qwerty-1"> = </span>
                   <span className="qwerty-1">"</span>
                   <span className="qwerty-3">ram</span>
                   <span className="qwerty-1">":</span>
                   <span className="qwerty-8"> lord</span>
                   <span className="qwerty-6">(</span>
                   <span className="qwerty-4">x</span>
                   <span className="qwerty-6">)</span>
               {"\n"}        
                   <span className="qwerty-10">God</span>
                   <span className="qwerty-1">()</span>
           {"\n"}{"\n"}
                </code>
       </pre>
       </div> 
       <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-3">Ram</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>    




<h2 className='headings'>Q-Write a Program if n value 0 after divide by 2 so Show True Check Python Lambda function examples use Return in the simple form.</h2>
      <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
     <pre style={{maxHeight:"500vh"}}>
         <code >
           {"\n"}
               <span className="qwerty-10">value</span>
                  <span className="qwerty-1"> = </span>
                   <span className="qwerty">lambda</span>
                   <span className="qwerty-4"> n</span>
                   <span className="qwerty-1"> : </span>
                   <span className="qwerty-4">n</span>
                   <span className="qwerty">%</span>
                   <span className="qwerty-2">2</span>
                   <span className="qwerty">==</span>
                   <span className="qwerty-8">0</span>
               {"\n"} 
               <span className="qwerty-3">print</span>
                   <span className="qwerty-1">(</span>
                   <span className="qwerty-10">value</span>
                   <span className="qwerty-6">(</span>
                   <span className="qwerty-8">8</span>
                   <span className="qwerty-6">)</span>
                   <span className="qwerty-1">)</span>                 
           {"\n"}{"\n"}
                </code>
       </pre>
       </div> 
       <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-2">True</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>      


<h3 className="mt-4 mh3">Lambda inline function is helpful because it contains only one expression. </h3>

<h2 className="mt-4 mh2">Python lambda Enumerate() function:</h2>
<p className="mt-4 para">Python lambda Enumerate() function are generally used with for loop to track the position of our item. </p>



<h2 className='headings'>Python Lambda Enumerate() function examples use return.</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-4">Names</span>
                <span className="qwerty-1"> = </span>
                <span className="qwerty-1">[</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">Ram</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">Lakshman</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">Bharat</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">]</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>        


<h2 className="mt-4 mh2">Python Lambda Function:</h2>
<p className="mt-4 para">The parameters of the lambda are known as the left of the colon. The function body is defined as the right of the colon.</p>



<h2 className='headings'>Q-Python Lambda Map() function examples?</h2>
      <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
     <pre style={{maxHeight:"500vh"}}>
         <code >
           {"\n"}
               <span className="qwerty-10">Number</span>
                  <span className="qwerty-1"> = </span>
                   <span className="qwerty">lambda</span>
                   <span className="qwerty-4"> n</span>
                   <span className="qwerty-1"> : </span>
                   <span className="qwerty-4">n</span>
                   <span className="qwerty">*</span>
                   <span className="qwerty-4">n</span>
               {"\n"} 
               <span className="qwerty-3">print</span>
                   <span className="qwerty-1">(</span>
                   <span className="qwerty-10">Number</span>
                   <span className="qwerty-6">(</span>
                   <span className="qwerty-8">8</span>
                   <span className="qwerty-6">)</span>
                   <span className="qwerty-1">)</span>                 
           {"\n"}{"\n"}
                </code>
       </pre>
       </div> 
       <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-2">64</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div> 


<h2 className="mt-4 mh2">Python Lambda Map ()Function:</h2>
<p className="mt-4 para">Map() function this function is iterable, and also map takes a function and a collection of items, and it returns the new collections.<br/>
 In the map, functions take two arguments:<br/>
1, iterable<br/>
2, function<br/>
</p>

<h2 className="mt-4 mh2"> Python Lambda built-in list() function</h2>
<p className="mt-3 para">the built-in list() function can be called on the map object .so I make a list(iterable)</p>



<h2 className='headings'>Python Lambda Map() function examples use return.</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">map</span>
                <span className="qwerty-1">(</span>
                <span className="qwerty-3">func</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty"> *</span>
                <span className="qwerty-4">iterables</span>
                <span className="qwerty-1">)</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>      



<h2 className='headings'>Q-Python Lambda Map() function firstly Capital Size and after append examples?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
          {"\n"}
                <span className="qwerty-4">city</span>
                <span className="qwerty-1"> = </span>
                <span className="qwerty-1">[</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">varanasi</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">ayodhya</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">Mathura</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">]</span>
                {"\n"} 
               <span className="qwerty-2">capital_city</span>
                   <span className="qwerty-1"> = </span>
                   <span className="qwerty-6">[ ]</span>
                {"\n"}  
                   <span className="qwerty-7">for </span>
                   <span className="qwerty-3">c</span>
                   <span className="qwerty-5"> in </span>
                   <span className="qwerty-4">city</span>
                   <span className="qwerty-1"> :</span>
                {"\n"} 
               <span className="qwerty-8">    large_city</span>
                   <span className="qwerty-1"> = </span>
                   <span className="qwerty-2">c</span>
                   <span className="qwerty">.</span>
                   <span className="qwerty-3">upper</span>
                   <span className="qwerty-1">()</span>
                {"\n"} 
               <span className="qwerty-2">    capital_city</span>
                   <span className="qwerty">.</span>
                   <span className="qwerty-3">append</span>
                   <span className="qwerty-1">(</span>
                   <span className="qwerty-8">large_city</span>
                   <span className="qwerty-1">)</span>
                {"\n"} 
               <span className="qwerty-3">    print</span>
                   <span className="qwerty-1">(</span>
                   <span className="qwerty-2">capital_city</span>
                   <span className="qwerty-1">)</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>          
        <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                  <span className="qwerty-1">[</span>
                <span className="qwerty-2">'</span>
                <span className="qwerty-3">VARANASI</span>
                <span className="qwerty-2">'</span>
                  <span className="qwerty-1">]</span>
                  {"\n"}
                  <span className="qwerty-1">[</span>
                <span className="qwerty-2">'</span>
                <span className="qwerty-3">VARANASI</span>
                <span className="qwerty-2">'</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-2">'</span>
                <span className="qwerty-3">AYODHYA</span>
                <span className="qwerty-2">'</span>
                  <span className="qwerty-1">]</span>
                  {"\n"}
                  <span className="qwerty-1">[</span>
                <span className="qwerty-2">'</span>
                <span className="qwerty-3">VARANASI</span>
                <span className="qwerty-2">'</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-2">'</span>
                <span className="qwerty-3">AYODHYA</span>
                <span className="qwerty-2">'</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-2">'</span>
                <span className="qwerty-3">MATHURA</span>
                <span className="qwerty-2">'</span>
                <span className="qwerty-1">]</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>


<h2 className="mt-4 mh2">Python lambda reduce () function:</h2>
<p className="mt-4 para">Python lambda reduce is a collection of items, and also it returns the sum of all items inside the group.</p>



<h2 className='headings'>Q-Python Lambda() reduce() function examples?</h2>
      <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
     <pre style={{maxHeight:"500vh"}}>
         <code >
           {"\n"}
               <span className="qwerty-5">from</span>
                  <span className="qwerty-7"> functools</span>
                   <span className="qwerty-6"> import</span>
                   <span className="qwerty-3"> reduce</span>
           {"\n"}
               <span className="qwerty-10">add</span>
                  <span className="qwerty-1"> = </span>
                   <span className="qwerty-3">reduce</span>
                  <span className="qwerty-1">(</span>
                   <span className="qwerty">lambda</span>
                   <span className="qwerty-4"> a</span>
                   <span className="qwerty-1"> ,</span>
                   <span className="qwerty-4"> x</span>
                   <span className="qwerty-1"> : </span>
                   <span className="qwerty-4">a</span>
                   <span className="qwerty">+</span>
                   <span className="qwerty-4">x</span>
                   <span className="qwerty-1">,</span>
                   <span className="qwerty-6"> [</span>
                   <span className="qwerty-2">10</span>
                   <span className="qwerty-1">,</span>
                   <span className="qwerty-2">20</span>
                   <span className="qwerty-1">,</span>
                   <span className="qwerty-2">50</span>
                   <span className="qwerty-1">,</span>
                   <span className="qwerty-2">20</span>
                   <span className="qwerty-6">]</span>
                   <span className="qwerty-1">)</span>
               {"\n"} 
               <span className="qwerty-3">print</span>
                   <span className="qwerty-1">(</span>
                   <span className="qwerty-10">add</span>
                
                   <span className="qwerty-1">)</span>                 
           {"\n"}{"\n"}
                </code>
       </pre>
       </div> 
       <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-2">100</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>    


<h2 className="mt-4 mh2">Python lambda Filter() Function :</h2>




      <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
     <pre style={{maxHeight:"500vh"}}>
         <code >
           {"\n"}
               <span className="qwerty-4">no</span>
                  <span className="qwerty-1"> = </span>
                   <span className="qwerty-1">[</span>
                   <span className="qwerty-10">1</span>
                   <span className="qwerty-1">,</span>
                   <span className="qwerty-10">2</span>
                   <span className="qwerty-1">,</span>
                   <span className="qwerty-10">3</span>
                   <span className="qwerty-1">,</span>
                   <span className="qwerty-10">4</span>
                   <span className="qwerty-1">,</span>
                   <span className="qwerty-10">5</span>
                   <span className="qwerty-1">,</span>
                   <span className="qwerty-10">6</span>
                   <span className="qwerty-1">,</span>
                   <span className="qwerty-10">7</span>
                   <span className="qwerty-1">,</span>
                   <span className="qwerty-10">8</span>
                   <span className="qwerty-1">,</span>
                   <span className="qwerty-10">9</span>
                   <span className="qwerty-1">,</span>
                   <span className="qwerty-10">10</span>
                   <span className="qwerty-1">]</span>
           {"\n"}
               <span className="qwerty-8">even</span>
                  <span className="qwerty-1"> = </span>
                   <span className="qwerty-3">tuple</span>
                  <span className="qwerty-1">(</span>
                   <span className="qwerty-7">filter</span>
                  <span className="qwerty-1">(</span>
                   <span className="qwerty">lambda</span>
                   <span className="qwerty-4"> a</span>
                   <span className="qwerty-1"> : </span>
                   <span className="qwerty-4">a</span>
                   <span className="qwerty">%</span>
                   <span className="qwerty-2">2</span>
                   <span className="qwerty">==</span>
                   <span className="qwerty-2">0</span>
                   <span className="qwerty-1">,</span>
                   <span className="qwerty-4">no</span>
                   <span className="qwerty-1">)</span>
                   <span className="qwerty-1">)</span>
           {"\n"}
               <span className="qwerty-8">odd</span>
                  <span className="qwerty-1"> = </span>
                   <span className="qwerty-3">tuple</span>
                  <span className="qwerty-1">(</span>
                   <span className="qwerty-7">filter</span>
                  <span className="qwerty-1">(</span>
                   <span className="qwerty">lambda</span>
                   <span className="qwerty-4"> a</span>
                   <span className="qwerty-1"> : </span>
                   <span className="qwerty-4">a</span>
                   <span className="qwerty">%</span>
                   <span className="qwerty-2">2</span>
                   <span className="qwerty">!=</span>
                   <span className="qwerty-2">0</span>
                   <span className="qwerty-1">,</span>
                   <span className="qwerty-4">no</span>
                   <span className="qwerty-1">)</span>
                   <span className="qwerty-1">)</span>
               {"\n"} 
               <span className="qwerty-3">print</span>
                   <span className="qwerty-1">(</span>
                   <span className="qwerty-8">even</span>
                   <span className="qwerty-1">)</span>                 
               {"\n"} 
               <span className="qwerty-3">print</span>
                   <span className="qwerty-1">(</span>
                   <span className="qwerty-8">odd</span>
                   <span className="qwerty-1">)</span>                 
           {"\n"}{"\n"}
                </code>
       </pre>
       </div> 
       <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-1">(</span>
                          <span className="qwerty-2">2</span>
                          <span className="qwerty-1">,</span>
                          <span className="qwerty-2">4</span>
                          <span className="qwerty-1">,</span>
                          <span className="qwerty-2">6</span>
                          <span className="qwerty-1">,</span>
                          <span className="qwerty-2">8</span>
                          <span className="qwerty-1">,</span>
                          <span className="qwerty-2">10</span>
                          <span className="qwerty-1">)</span>
                  {"\n"}
                          <span className="qwerty-1">(</span>
                          <span className="qwerty-2">1</span>
                          <span className="qwerty-1">,</span>
                          <span className="qwerty-2">3</span>
                          <span className="qwerty-1">,</span>
                          <span className="qwerty-2">5</span>
                          <span className="qwerty-1">,</span>
                          <span className="qwerty-2">7</span>
                          <span className="qwerty-1">,</span>
                          <span className="qwerty-2">9</span>
                          <span className="qwerty-1">)</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>  

  <h1 className="mt-5">  </h1>
  
  <div className="back">
        <a href="/python-continue">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-list">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Plambda;